import { useEffect } from "react";
import Page from "../../../../components/Layout/Page";
import T from "../../../../components/Typography";
import Button from "../../../../components/Button";
import { useIsMobile } from "../../../../helpers/ui";
import { SectionFlexRow } from "../../../../components/General";
import { colors } from "../../../../styles";
import { Card, MobileHeader, DesktopHeader } from "../Account/components";
import {
  YourAccounts,
  YourRecentTransfers,
  OtherOptions,
  TransfersPageContent,
} from "./components";
import { useNavigate } from "react-router-dom";
import {
  employeeTransfersAddMoneyPath,
  employeeTransfersSendMoneyPath,
} from "../../../../routes/paths";
import { useStoreActions } from "../../../../store";

const Transfers = () => {
  const transferActions = useStoreActions((actions) => actions.transfer);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  useEffect(() => {
    // reset transfer flow state so that we start fresh when starting a new transfer
    transferActions.resetState();
  }, [transferActions]);

  const navToAddMoney = () => {
    navigate(employeeTransfersAddMoneyPath);
  };

  const navToSendMoney = () => {
    navigate(employeeTransfersSendMoneyPath);
  };

  return (
    <Page>
      {isMobile ? (
        <MobileHeader title="Transfers" showBack showClose={false} />
      ) : (
        <DesktopHeader>
          <SectionFlexRow>
            <T variant="headingMd">Transfers</T>
            <SectionFlexRow sx={{ justifyContent: "flex-end", gap: "8px" }}>
              <Button
                btntype="secondary"
                noMargin
                width="109px"
                onClick={navToAddMoney}
              >
                Add Money
              </Button>
              <Button noMargin width="109px" onClick={navToSendMoney}>
                Send Money
              </Button>
            </SectionFlexRow>
          </SectionFlexRow>
        </DesktopHeader>
      )}
      <TransfersPageContent>
        <div style={{ marginTop: 32 }}>
          {isMobile ? (
            <SectionFlexRow sx={{ gap: "8px" }}>
              <Button
                btntype="secondary"
                noMargin
                fullWidth
                backgroundColor={colors.purple_300}
                textColor={colors.white}
                onClick={navToAddMoney}
              >
                Add Money
              </Button>
              <Button
                noMargin
                fullWidth
                backgroundColor={colors.green_teal}
                onClick={navToSendMoney}
              >
                Send Money
              </Button>
            </SectionFlexRow>
          ) : (
            <T variant="lgMed" color={colors.gray_600}>
              Move money to and from your connected accounts
            </T>
          )}
        </div>
        <div style={{ paddingBottom: "64px" }}>
          <Card hideStyleOnMobile>
            <YourAccounts />
            <YourRecentTransfers />
            <OtherOptions />
          </Card>
        </div>
      </TransfersPageContent>
    </Page>
  );
};

export default Transfers;
